import { InputHTMLAttributes, useRef } from 'react';

import { useEventCallback } from '@spazious/react-hooks';

import { Button, ButtonProps } from '../Button/index.js';

interface InputFileProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label: React.ReactNode;
  onUpload: (file: File) => void;
  size: ButtonProps['size'];
  disabled?: boolean;
}

export const InputFile: React.FC<InputFileProps> = ({
  onUpload,
  label,
  size,
  disabled = false,
  ...restProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = useEventCallback(() => {
    inputRef.current?.click();
  });

  // Reset the input value to allow uploading the same file again
  const resetInputFileValue = useEventCallback(() => {
    inputRef.current && (inputRef.current.value = '');
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.target?.files?.length) {
      onUpload(e.target.files[0]);
      resetInputFileValue();
    }
  };
  return (
    <>
      <Button disabled={disabled} size={size} onClick={handleClick}>
        {label}
      </Button>

      <input
        {...restProps}
        ref={inputRef}
        accept=".xlsx"
        id="file"
        style={{ display: 'none' }}
        type="file"
        onChange={handleFileChange}
      />
    </>
  );
};
